import { Plus } from "lucide-react"
import { SystemUsageData } from "../../../../types"
import { numberToUSD } from "../../../utils"
import If from "../../if"

interface Props {
  usage: SystemUsageData
}

const Footer = ({ usage }: Props) => (
  <div className="sm:flex justify-between w-full">
    <div className="h-16 px-4 py-1 bg-gray-100 flex items-center w-full">
      <div>
        <span className="block text-xs">Subscription</span>
        <strong className="text-sm font-bold">
          {numberToUSD(usage?.breakdown.cost.breakdown.base ?? 0)}
        </strong>
      </div>

      <Plus size={16} className="mx-2" />

      <div>
        <span className="block text-xs">Leads</span>
        <strong className="text-sm font-bold">
          {numberToUSD(usage?.breakdown.cost.breakdown?.leads?.total ?? 0)}
        </strong>
      </div>

      <Plus size={16} className="mx-2" />

      <div>
        <span className="block text-xs">Emails</span>
        <strong className="text-sm font-bold">
          {numberToUSD(usage?.breakdown.cost.breakdown?.emails?.total ?? 0)}
        </strong>
      </div>

      <If
        condition={!!usage?.breakdown.cost.breakdown?.sms?.total}
        then={
          <>
            <Plus size={16} className="mx-2" />
            <div>
              <span className="block text-xs">SMS</span>
              <strong className="text-sm font-bold">
                {numberToUSD(usage?.breakdown.cost.breakdown?.sms?.total ?? 0)}
              </strong>
            </div>
          </>
        }
      />

      <If
        condition={
          !!usage?.breakdown.cost.breakdown?.addons?.breakdown?.[0]?.type
        }
        then={
          <>
            <Plus size={16} className="mx-2" />
            <div>
              <span className="block text-xs">Addons</span>
              <strong className="text-sm font-bold">
                {numberToUSD(
                  usage?.breakdown.cost.breakdown?.addons?.total ?? 0
                )}
              </strong>
            </div>
          </>
        }
      />
    </div>

    <div className="items-center justify-end w-full sm:w-48 h-16 px-4 py-1 bg-black text-white flex shrink-0">
      <span className="text-sm font-medium uppercase ml-4">total</span>
      <strong className="font-extrabold text-lg ml-2 sm:ml-auto">
        {numberToUSD(usage.total)}
      </strong>
    </div>
  </div>
)

export default Footer
